import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

// Sprint 2.4 (Enterprise Design System Foundation): no empty-state pattern existed before — admin
// list pages previously just rendered an empty table. Used by the new Governance/Config/Compliance
// pages when a list has zero rows.
const EmptyState = ({ icon, title, description }) => (
  <div className="ent-empty-state" role="status" aria-live="polite">
    <Icon type={icon || 'inbox'} className="ent-empty-state-icon" />
    <div className="ent-empty-state-title">{title}</div>
    {description && <div className="ent-empty-state-description">{description}</div>}
  </div>
);

EmptyState.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.node
};

export default EmptyState;
